import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditUserComponent } from './users-settings/edit-user/edit-user.component';
import { ProfileComponent } from './profile/profile.component';
import { UserComponent } from './user.component';
import { UserRoutingModule } from './user-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderModule } from 'src/app/shared/header/header.module';
import { MaterialExampleModule } from 'src/material.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmDialogModule } from 'src/app/shared/components/confirm-dialog/confirm-dialog.module';
import { MatOptionModule } from '@angular/material/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AccountMarginComponent } from './utils/account-margin/account-margin.component';


@NgModule({
  declarations: [ 
    UserComponent, 
    EditUserComponent,
    ProfileComponent,
    AccountMarginComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    FormsModule,
    HeaderModule,
    MaterialExampleModule,
    MatTabsModule,
    MatIconModule,
    MatSelectModule,
    ConfirmDialogModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    DirectivesModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  exports: [
    EditUserComponent
  ]
})
export class UserModule { }
